<script>
  export default {
    name: 'usage-form',
    props: {
      isEnergyReport: {
        type: Boolean,
        default: false
      },
      selectedTrailers: {
        type: Array,
        default: () => []
      }
    },
    data: () => ({
      intervalSelect: 'minute',
      usageDate: null,
      // usagePeriodOptions: [
      //   {
      //     text: 'Date',
      //     value: 'date'
      //   },
      //   {
      //     text: 'Range',
      //     value: 'range'
      //   },
      //   {
      //     text: 'Month',
      //     value: 'month'
      //   }
      // ],
      periodSelect: 'custom'
    }),
    computed: {
      selectedDatesText() {
        if (this.periodSelect === 'range' && this.usageDate?.length) {
          return [...this.usageDate].sort((a, b) => a.localeCompare(b)).join(' - ')
        }
        return undefined
      },
      trailersList() {
        return this.$store.state.selectedTrailers?.length ?  this.$store.state.selectedTrailers : this.selectedTrailers
      },
      usageUrl() {
        if (!this.trailersList?.length || !this.intervalSelect || !this.periodSelect || !this.usageDate?.length) {
          return '#'
        }

        // const baseUrl = window.location.origin + '/usage'
        const baseUrl = '/usage'
        const datesArr = Array.isArray(this.usageDate) ? [...this.usageDate] : [this.usageDate]
        const sortedDates = datesArr.sort((a, b) => a.localeCompare(b))
        const uriDates = sortedDates.join(',')
        const uriTrailers = this.trailersList.map(t => t.id).join(',')
        const params = {
          interval: this.intervalSelect,
          period: this.periodSelect,
          dates: uriDates,
          trailers: uriTrailers
        }
        if (this.isEnergyReport) {
          params.report = 'energy'
        }
        const searchParams = new URLSearchParams(params)
        // let urlParams = new URL(`?${searchParams.toString()}`, baseUrl)
        return `${baseUrl}?${searchParams.toString()}`
      }
    },
    methods: {
      async onGetUsage() {
        //OLD, WILL REMOVE
        // const paramsObj = { foo: "bar", baz: "bar" };
        // const searchParams = new URLSearchParams(paramsObj);
        // console.log(searchParams.toString()); // "foo=bar&baz=bar"

        // let url = '?'
        if (this.periodSelect === 'range') {
          const [startDate, endDate] = this.usageDate
          if (!startDate) {
            console.error('NO START DATE - handle front end')
          }
          if (!endDate) {
            console.error('NO END DATE - handle front end')
          }
          url += `start=${startDate}`
          if (endDate) {
            url += `&end=${endDate}`
          }
        } else {
          url += `start=${this.usageDate}`
          url += `&end=${this.usageDate}`
        }
        if (!this.trailersList?.length) {
          console.error('NO TRAILERS SELECTED - handle front end')
        }

        const arrayStr = this.trailersList.reduce((acc, curr) => {
          return (acc += `&units=${encodeURI(curr.id)}`)
        }, '')
        url += arrayStr

        this.$router.push(`/usage${url}`)
        //todo href computed property to make button a link

        // const test = await api.get(`sol/plant-usage${url}`)
        // console.log(test)
        return url
      },
      onperiodSelectChange(v) {
        this.usageDate = null
        this.settingsSave()
      },
      settingsLoad() {
        const validIntervalSettings = ['day', 'minute']
        const intervalSetting = localStorage.getItem('usage-interval')
        if (validIntervalSettings.includes(intervalSetting)) {
          this.interval = intervalSetting
        }
        const validPeriodSettings = ['custom', 'range', 'month']
        const periodSetting = localStorage.getItem('usage-period')
        if (validPeriodSettings.includes(periodSetting)) {
          this.period = periodSetting
        }
      },
      settingsSave() {
        localStorage.setItem('usage-interval', this.interval)
        localStorage.setItem('usage-filetype', this.period)
      }
    },
    created() {
      if (this.isEnergyReport) {
        this.intervalSelect = 'minute'
        this.periodSelect = 'range'
      } else {
        this.settingsLoad
      }
    }
  }
</script>

<template>
  <v-card class="default-dialog">
    <v-icon color="primary" @click="$emit('close')" class="close-btn">mdi-close</v-icon>
    <v-card-title class="primary--text"> {{ isEnergyReport ? 'ENERGY' : 'USAGE' }} REPORT</v-card-title>
        <p class="mb-0 warning--text text-left px-4"><v-icon x-small color="warning" left>mdi-alert</v-icon>5min interval is required to generate energy graphic.</p>
    <v-card-text class="pa-6">
      <v-row>
        <v-col v-if="!isEnergyReport" cols="12">
          <p class="primary--text font-weight-bold text-left text-body-1 mb-0">Interval</p>
          <v-radio-group v-model="intervalSelect" :disabled="!trailersList?.length" hide-details dense row @change="settingsSave" class="mt-0">
            <v-radio label="5 Min" value="minute"></v-radio>
            <v-radio label="Daily" value="day"></v-radio>
          </v-radio-group>
          <!-- <v-select
                        v-model="intervalSelect"
                        color="primary"
                        :disabled="!trailersList?.length"
                        hide-details
                        :items="intervalOptions"
                        label="Period"
                        class="text-left"
                        @change="onIntervalSelectChange"
                      >
                        <template v-slot:item="{ item }">
                          <div class="text-left">{{ item.text }}</div>
                        </template>
                      </v-select> -->
        </v-col>
        <v-col v-if="!isEnergyReport" cols="12">
          <p class="primary--text font-weight-bold text-left text-body-1 mt-2 mb-0">Time Frame</p>
          <v-radio-group v-model="periodSelect" :disabled="!trailersList?.length" hide-details dense row @change="onperiodSelectChange" class="mt-0">
            <v-radio label="Selection" value="custom"></v-radio>
            <v-radio label="Range" value="range"></v-radio>
            <v-radio label="Month" value="month"></v-radio>
          </v-radio-group>
          <!-- :range="periodSelect === 'range'" -->
        </v-col>
        <v-col cols="12" class="text-left mt-2">
          <v-btn color="error" :disabled="!usageDate?.length" text dense outlined small @click="usageDate = []" class="mb-1"
            ><v-icon left small>mdi-close</v-icon> clear selection</v-btn
          >
          <v-date-picker
            v-model="usageDate"
            :key="periodSelect"
            full-width
            :multiple="periodSelect === 'custom'"
            :range="periodSelect === 'range'"
            :month="periodSelect === 'month'"
            :selected-items-text="selectedDatesText"
            :type="periodSelect === 'month' ? 'month' : 'date'"
            scrollable
            class=""
          ></v-date-picker>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-8 pt-0">
      <v-btn block color="primary" :disabled="isEnergyReport ? !Array.isArray(usageDate) : !usageDate" :to="usageUrl || '#'"
        ><v-icon left>{{ `mdi-${isEnergyReport ? 'chart-arc' : 'generator-portable'}` }}</v-icon
        ><span class="font-weight-bold">GET REPORT</span></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
